export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'ListIcon', is_bookmarked: false},
      {title: 'Packages', url: '/packages/list', icon: 'ListIcon', is_bookmarked: false},
    ]
  }
}
